import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/candidate/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/candidate/settings/profile" })
  },
  component: () => null,
})
